import entry from './entry';
import ranking from './ranking';

export default {
	...entry,
	...ranking,
};
